module.exports = __webpack_public_path__ + "static/UDAHB-8095562138d456a6d99611a019f82757.png";